<template>
  <div :style="'background:' + bgColor">
   <Cheader />
    <back-img />
    <router-view />

    <el-backtop />
    <Cfooter />
  </div>
</template>

<script>
import Cheader from "@/layout/components/header/index.vue";
import Cfooter from "@/layout/components/footer/index.vue";
import backImg from "@/components/backImg/index.vue";
import  {mapState} from 'vuex'
export default {
  name: "layout",
  components: {
    Cheader,
    Cfooter,
    backImg
  },
  computed: {
    ...mapState(['bgColor'])
  }
}
</script>

<style scoped>

</style>
